import React from "react";

const Add = () => {
  return (
    <svg
      width="50px"
      height="25px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Buton add</title>
      <g
        id="Kanban-Dashboard-UI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Tasks" transform="translate(-277.000000, -153.000000)">
          <g id="Buton-add" transform="translate(277.000000, 153.000000)">
            <path
              d="M10,0 C15.522,0 20,4.478 20,10 C20,15.522 15.522,20 10,20 C4.478,20 0,15.522 0,10 C0,4.478 4.478,0 10,0"
              id="Fill-1"
              fill="#186BFE"
            ></path>
            <path
              d="M9,9 L9,5 C9,4.447 9.447,4 10,4 C10.553,4 11,4.447 11,5 L11,9 L15,9 C15.553,9 16,9.447 16,10 C16,10.553 15.553,11 15,11 L11,11 L11,15 C11,15.553 10.553,16 10,16 C9.447,16 9,15.553 9,15 L9,11 L5,11 C4.447,11 4,10.553 4,10 C4,9.447 4.447,9 5,9 L9,9 Z"
              id="Fill-3"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Add;
